import { Box, Stack, Typography, CircularProgress } from '@mui/material';
import { AISuggestionsTitle } from './AISuggestionsTitle';

export const AISuggestionsLoadingState = () => (
  <Stack gap={0.625}>
    <AISuggestionsTitle />
    <Box
      style={{
        border: '2px dashed #ccc',
        borderRadius: '8px',
        padding: '24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '120px',
        backgroundColor: '#f8f9fa',
      }}
    >
      <CircularProgress size={32} />
      <Typography variant="body2" color="text.secondary" style={{ marginTop: '8px' }}>
        AI is analyzing your file...
      </Typography>
    </Box>
  </Stack>
);
